import React from 'react'
import styles from './FriendsActivity.scss'
import {TripListItem, RouteListItem, GearListItem, SubscriptionListItem} from 'common/ListItems'
import {Route, Trip, Gear, Subscription} from 'data/records'
import {CTA} from 'common/styleguide/CTA'
import {CircleSpinner} from 'common/spinners/CircleSpinner'
import cardStyles from 'common/SearchableCard/SearchableCard.scss'
import {DEFAULT_PER_PAGE} from 'lib/loadAllPages'

export class FriendsActivity extends React.PureComponent {
  render () {
    const {
      feed: {results, extras, total_count: totalCount},
      currentUser,
      loadMore,
      loadingMore,
      offset
    } = this.props
    const zipped = results && extras
      ? pick(results, extras)
      : []

    return (
      <div className={styles.FriendsActivity}>
        {zipped.map(z => z[1] && <ActivityItem key={z[1].id} r={z[0]} e={z[1]} currentUser={currentUser} />)}
        {totalCount > results.length && totalCount > DEFAULT_PER_PAGE &&
          <div className={cardStyles.resultsFooter}>
            <CTA inline secondary margins={false} disabled={loadingMore} onClick={() => !loadingMore && loadMore()}>
              {loadingMore && <CircleSpinner size={14} />} Load more
            </CTA>
          </div>}
        {!loadingMore &&
          totalCount > DEFAULT_PER_PAGE &&
          (offset + DEFAULT_PER_PAGE) >= totalCount &&
          <div className={cardStyles.resultsFooter}>
            <span className={cardStyles.footerText}>No more items to display</span>
          </div>}
      </div>
    )
  }
}

const pick = (results, extras) => (results.map(r => [r, extras.filter(e => e && e.id === r.associatedObjectId)[0]]))

const ActivityItem = ({r, e, currentUser}) => {
  const friend = {
    name: r.content.user_name,
    id: r.content.user_id,
    highlightedPhotoId: r.content.highlighted_photo_id
  }

  if (e instanceof Route) {
    return <RouteListItem isFeedEntry route={e} friend={friend} />
  } else if (e instanceof Trip) {
    return <TripListItem isFeedEntry trip={e} friend={friend} />
  } else if (e instanceof Gear) {
    return <GearListItem isFeedEntry gear={e} friend={friend} />
  } else if (e instanceof Subscription) {
    return <SubscriptionListItem isFeedEntry subscription={e} currentUser={currentUser} friend={friend} />
  }
}
